import { useId, useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronUp } from "lucide-react";

import LiveSessionCard from "@/domains/certifications/components/LiveSessionCard";
import { LiveSessionsStripProps } from "@/features/certifications/module/components/types";

import "./styles.css";

const ICON_SIZE = 18;

const LiveSessionsStrip = ({ sessions }: LiveSessionsStripProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);
  const panelId = useId();
  const titleId = useId();
  const noteId = useId();

  if (sessions.length === 0) {
    return null;
  }

  return (
    <section className="module-live-strip flex flex-col gap-200">
      <h2 className="certification-heading header-s-medium">
        <button
          type="button"
          className="module-live-toggle flex flex-wrap items-center justify-between gap-300 full-width"
          aria-expanded={isOpen}
          aria-controls={panelId}
          aria-labelledby={titleId}
          aria-describedby={noteId}
          onClick={() => setIsOpen((open) => !open)}
        >
          <span className="flex items-center gap-200">
            <span className="module-live-dot" aria-hidden />

            <span id={titleId}>
              {t("certification.labels.liveSessions.title")}
            </span>
          </span>

          <span className="flex items-center gap-300">
            <span id={noteId} className="certification-muted body-xs-regular">
              {t("certification.labels.liveSessions.note")}
            </span>

            {isOpen ? (
              <ChevronUp size={ICON_SIZE} aria-hidden />
            ) : (
              <ChevronDown size={ICON_SIZE} aria-hidden />
            )}
          </span>
        </button>
      </h2>

      <div
        id={panelId}
        className={
          isOpen ? "certification-card-row flex flex-wrap gap-300" : ""
        }
        hidden={!isOpen}
      >
        {sessions.map((session) => (
          <LiveSessionCard key={session.id} session={session} />
        ))}
      </div>
    </section>
  );
};

export default LiveSessionsStrip;
